import MethodLabel from './MethodLabel';

export default MethodLabel;